import { withChildren } from '@builder.io/react';
import { BuilderConfig } from '../../types/Builder';
import BusinessHubVideoHero, { BusinessHubUsedByProps } from './business-hub-used-by';

export const BusinessHubUsedByBuilderConfig = {
    name: 'Business Hub Used By',
    inputs: [
        {
            name: 'title',
            type: 'html',
            defaultValue: '',
        },
        {
            name: 'subTitle',
            type: 'html',
            defaultValue: '',
        },
        {
            name: 'listItem',
            type: 'list',
            subFields: [
                {
                    name: 'textNumber',
                    type: 'html',
                    defaultValue: '',
                },
                {
                    name: 'subNumber',
                    type: 'html',
                    defaultValue: '',
                },
                {
                    name: 'subNumberMaxWidth',
                    type: 'number',
                    min: 234,
                },
                {
                    name: 'order',
                    type: 'number',
                    min: 0,
                },
            ],
        },
    ],
};

const builderConfig: BuilderConfig<BusinessHubUsedByProps> = {
    component: withChildren(BusinessHubVideoHero),
    config: BusinessHubUsedByBuilderConfig,
};

export default builderConfig;
